import React, { Component, createRef } from 'react';
import { Form, Input, Select, DatePicker, Row, Col, Button, InputNumber, Pagination } from 'antd';
import moment from 'moment';
import { getOrderDomesticSelect } from './api';
import CpEmpty from '../../components/CpEmpty';
import SearchItem from './components/SearchItem';

const { Option } = Select;
const { RangePicker } = DatePicker;
const TransportOptions = [
  {
    key: '陆运',
    value: 1
  },
  {
    key: '海运',
    value: 2
  },
  {
    key: '空运',
    value: 3
  },
  {
    key: '陆铁联运',
    value: 4
  }
];

// 1-计划收集待开始 2-计划收集中 3-采购待开始 4-采购中 5-已结束 6-已取消
const planPurchaseStatusList = [
  {
    key: "全部/All",
    value: '',
  },
  {
    key: "已报价/Create",
    value: 1,
  },
  {
    key: "提报中/Plan Collection",
    value: 2,
  },
  {
    key: "待采购/Wait Purchase",
    value: 3,
  },
  {
    key: "采购中/Purchase",
    value: 4,
  },
  {
    key: "已结束/Finish",
    value: 5,
  }
];
export default class QuotationSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      size: 'default',
      page_size: 10,
      total: 0,
      current: 1,
      selectList: [],
      parentList: [],
      childrenList: [],
      container_num: 1,
      isDisable: 0,
      isModalVisible: false,
      currentSubmits: [],
      emptyStatus: '',
      area: [],
      areaChildren: [],
      port: [],
    };
    this.formRef = createRef();
  }

  async componentDidMount() {
    this.requestOrderDomesticSelect();
  }
  componentWillUnmount() {
    this.setState = () => false;
  }

  formateMoment = (values, value) => {
    const current = values[value] || [];
    let startTime, endTime;
    if (current.length) {
      const [start, end] = current;
      startTime = moment(start).format('YYYY-MM-DD');
      endTime = moment(end).format('YYYY-MM-DD');
    }
    return { [`${value}_start`]: startTime, [`${value}_end`]: endTime };
  }
  requestOrderDomesticSelect = async () => {
    try {
      const formValue = this.formRef.current.getFieldsValue();
      // const { container_num = 1, expected_arrival_port } = formValue;
      const { container_num = 1 } = formValue;
      const estimated_departure_date = this.formateMoment(formValue, 'estimated_departure_date');
      const create_time = this.formateMoment(formValue, 'create_time');
      const estimated_arrival_data = this.formateMoment(formValue, 'estimated_arrival_data');
      const purchase = this.formateMoment(formValue, 'purchase');
      const plan_collect = this.formateMoment(formValue, 'plan_collect');
      const { current, page_size } = this.state;
      const postData = { ...formValue, ...create_time, ...estimated_departure_date, ...estimated_arrival_data, ...plan_collect, ...purchase, page: current, page_size, };
      const { data: { data = {}, code } } = await getOrderDomesticSelect(postData);
      if (+code === 0) {
        const { list: dataSource = [], page, total, select: { area = [], port = [] } } = data;
        // const childrenList = Array.from(new Set(select.filter(item => (!expected_arrival_port || item.name === expected_arrival_port)).reduce((pre, next) => ([...pre, ...next.child]), [])));
        // console.log(JSON.stringify(childrenList, null, 2), childrenList.map(item => item.id));
        // this.setState({ current: page, total, dataSource, selectList: select, parentList: [...select], childrenList, container_num, emptyStatus: dataSource.length ? '' : 'quotationSearch' });
        this.setState({ current: page, total, dataSource, area, port, container_num, emptyStatus: dataSource.length ? '' : 'quotationSearch' });
      }
    } catch (error) {
      this.setState({ loading: false });
    }
  }

  handleSubmit = () => {
    this.setState({ current: 1 }, () => { this.requestOrderDomesticSelect(); });
  }
  handleReset = () => {
    this.formRef.current.resetFields();
    this.setState({ current: 1, isDisable: 0 }, () => { this.requestOrderDomesticSelect(); });
  }
  onChangePage = (current, page_size) => {
    this.setState({ current, page_size }, () => {
      this.requestOrderDomesticSelect();
    });
  };
  changeTransport = (e) => {
    this.requestOrderDomesticSelect();
    const { selectList = [] } = this.state;
    const parentList = selectList?.[e - 1] ? [selectList?.[e - 1]] : [];
    const childrenList = selectList?.[e - 1]?.child || [];
    this.setState({ parentList, childrenList, isDisable: e });
    this.formRef.current.setFieldsValue({ expected_arrival_port: undefined, city_name: undefined });
  };
  changeArrivalPort = (e) => {
    const { selectList = [] } = this.state;
    const childrenList = selectList.find(item => item?.name === e)?.child || [];
    this.setState({ childrenList });
    this.formRef.current.setFieldsValue({ city_name: undefined });
  };
  provinceChange = (e) => {
    const { area = [] } = this.state;
    const { child = [] } = area.find(item => item.id === e);
    this.setState({ areaChildren: child }, () => {
      this.formRef.current.setFieldsValue({ city_id: undefined });
    });

  }
  render() {
    const { page_size, total, current, dataSource = [], emptyStatus, port = [], area = [], areaChildren = [] } = this.state;
    const empty = (
      <div className="cart-empty">
        <CpEmpty status={emptyStatus} history={this.props.history} />
      </div>
    );
    return (
      <div>
        <Form
          className='quotation-form'
          name="basic"
          labelCol={{ span: 9 }}
          wrapperCol={{ span: 15 }}
          onFinish={this.handleSubmit}
          ref={this.formRef}
          style={{ paddingTop: '30px', background: 'white', borderRadius: 10 }}
        >
          <Row>
            <Col span={8}>
              <Form.Item label="运输方式：" name='transportation_form'>
                <Select onChange={(e) => this.changeTransport(e)} placeholder="请选择运输方式">{TransportOptions.map(item => <Option key={item?.value} value={item?.value}>{item?.key}</Option>)}</Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="出发地：" name='expected_arrival_port'>
                <Select onChange={(e) => this.changeArrivalPort(e)} placeholder="请选择出发地">{port.map(item => <Option key={item} value={item}>{item}</Option>)}</Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="到达城市：" >
                <Input.Group compact>
                  <Form.Item name='province_id' noStyle>
                    <Select placeholder="请选择省" onChange={(e) => this.provinceChange(e)} style={{ width: 125, textAlign: 'center' }}>{area.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}</Select>
                  </Form.Item>
                  <Form.Item name='city_id' noStyle>
                    <Select placeholder="请选择市" style={{ width: 125, textAlign: 'center' }}>{areaChildren.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}</Select>
                  </Form.Item>
                </Input.Group>
                {/* <Select placeholder="请选到达城市">{childrenList.map(item => <Option key={item} value={item}>{item}</Option>)}</Select> */}
              </Form.Item>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <Form.Item label="预计离港周期(ETD)：" name='estimated_departure_date'>
                <RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="预计到港日期(ETA)：" name='estimated_arrival_data'>
                <RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="报价创建日期：" name='create_time'>
                <RangePicker />
                {/* <DatePicker className='ant-picker-create' /> */}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="计划收集日期：" name='plan_collect'>
                <RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="采购日期：" name='purchase'>
                <RangePicker />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="商品名称：" name='sku_name'>
                <Input placeholder=" 请输入商品名称" />
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item label="箱报价范围：">
                <Input.Group compact>
                  <Form.Item name='box_price_min' noStyle>
                    <InputNumber style={{ width: 110, textAlign: 'center' }} placeholder="最低价" min={0} />
                  </Form.Item>
                  <Input className="site-input-split" style={{ width: 30, borderLeft: 0, borderRight: 0, pointerEvents: 'none', }} placeholder="~" disabled />
                  <Form.Item name='box_price_max' noStyle>
                    <InputNumber className="site-input-right" style={{ width: 110, textAlign: 'center', }} placeholder="最高价" min={0} />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="报价单编号：" name='quotation_no'>
                <Input placeholder=" 请输入报价单编号" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="报价单状态：" name='plan_purchase_status'>
                <Select placeholder="请选择报价单状态">{planPurchaseStatusList.map(item => <Option key={item.value} value={item.value}>{item.key}</Option>)}</Select>
              </Form.Item>
            </Col>

          </Row>
          <Row>
          <Col span={8} offset={16}>
              <Form.Item wrapperCol={{ offset: 14, span: 10 }}>
                <Button type="primary" htmlType="submit">报价查询</Button>
                <Button style={{ marginLeft: 8 }} onClick={this.handleReset}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
        {
          dataSource.length ? <div className='quotation-list'>
            {(dataSource || []).map((item, index) => <SearchItem key={`${item?.quotation_no}-${index}`} {...{ item, TransportOptions, requestOrderDomesticSelect: this.requestOrderDomesticSelect }} />)}
            <div style={{ textAlign: 'right' }}>
              <Pagination
                current={current}
                pageSize={page_size}
                total={total}
                onChange={(current, page_size) => {
                  this.onChangePage(current, page_size);
                }}
              /></div>
          </div> : <>{empty}</>
        }
      </div>
    );
  }
}

